import { Carousel } from './Carousel';

export const SSR = {
    Carousel,
};
